import axios from 'axios';
import ProviderReviewTransformer from '../../transformers/providerReview';
import tableUtil from '../../utils/table';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    let params = query || {};

    axios.get(process.env.VUE_APP_API_ADMIN_LOCATION + 'reviews', { params }).then(
      ({ data }) => {
        let dataRes = {};

        if (data.data) {
          dataRes.data = ProviderReviewTransformer.fetch(data.data);
        }
        dataRes.meta = data.pagination ? { pagination: data.pagination } : tableUtil.mockupMeta(dataRes.data.length);
        resolve(dataRes);
      },
      (error) => {
        reject(error);
      }
    );
  });

  return promise;
};
